import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import { Loading } from 'element-ui'
Vue.prototype.$loading = Loading.service

Vue.use(Element)
